import Http from 'services/Http';
import sanitizeAgenticBody from './sanitizeAgenticBody';

class KnowledgeApi {
  list() {
    return Http.get('/v1/knowledge').then(r => r.data.knowledge || []);
  }

  listFolderOptions(knowledgeId = null) {
    const q = knowledgeId ? `?knowledgeId=${encodeURIComponent(knowledgeId)}` : '';
    return Http.get(`/v1/knowledge/folders${q}`).then(r => r.data.folders || []);
  }

  get(id) {
    return Http.get(`/v1/knowledge/${id}`).then(r => r.data.knowledge);
  }

  create(body) {
    return Http.post('/v1/knowledge', sanitizeAgenticBody(body)).then(r => r.data.knowledge);
  }

  update(id, body) {
    return Http.put(`/v1/knowledge/${id}`, sanitizeAgenticBody(body)).then(r => r.data.knowledge);
  }

  destroy(id) {
    return Http.delete(`/v1/knowledge/${id}`);
  }

  query(id, query) {
    return Http.post(`/v1/knowledge/${id}/query`, { query }).then(r => r.data);
  }

  listDocuments(id) {
    return Http.get(`/v1/knowledge/${id}/documents`).then(r => r.data);
  }

  reindex(id) {
    return Http.post(`/v1/knowledge/${id}/reindex`).then(r => r.data);
  }
}

export default new KnowledgeApi();
